import { useTranslation } from 'react-i18next';
import HomeNotice from '@/components/app/home/HomeNotice';
import { ROUTES } from '@/routes/paths';

interface StartTradingCardProps {
  /** 'sell' — производителю: создать предложение о продаже; 'buy' — не-производителю: создать прайс-лист. */
  readonly mode: 'sell' | 'buy';
  /** true — пользователь уже торговал (нет активного листинга, но был раньше): напоминание, а не «первое». */
  readonly returning?: boolean;
}

/**
 * Напоминание «Главной» аттестованной организации без листинга: сельхозтоваропроизводителю — создать
 * предложение о продаже, остальным — прайс-лист. Оформлено как «Добавьте сотрудников», но без крестика:
 * без листинга торговать нельзя. Исчезает, когда листинг создан (условие показа — в AppHome).
 */
export default function StartTradingCard({ mode, returning = false }: StartTradingCardProps) {
  const { t } = useTranslation();
  const base = mode === 'sell' ? 'app.home.startTrading.sell' : 'app.home.startTrading.buy';
  return (
    <HomeNotice
      title={t(returning ? `${base}.titleAgain` : `${base}.title`)}
      hint={t(returning ? `${base}.hintAgain` : `${base}.hint`)}
      action={{ to: mode === 'sell' ? ROUTES.APP_SELL_NEW : ROUTES.APP_BUY_NEW, label: t(`${base}.cta`) }}
    />
  );
}
